import { __assign } from "tslib";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
import { useContext, createContext } from "react";
export var AppLayoutContext = /*#__PURE__*/ createContext({
    stickyOffsetTop: 0,
    stickyOffsetBottom: 0
});
export function useAppLayoutContext() {
    var context = useContext(AppLayoutContext);
    return __assign({}, context);
} //# sourceMappingURL=app-layout-context.js.map
